import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core';
import GroupsSearchModal from './GroupsSearchModal';
import styles from './GroupsSearchModal.styles';
import { fetchClientGroups, fetchGroupClients } from '../../modules/clients/actions';

const mapStateToProps = ({
  clientsModule: {
    groups: { data, loading: clientsGroupsLoading },
  },
}) => ({
  clientsGroupsLoading,
  clientsGroups: data.filter((group) => group.groupId !== 'clientList' && group.clientsCount),
});

const mapDispatchToProps = (dispatch) => {
  const getClientGroups = () => fetchClientGroups({ isApiV2: true, includeStats: true });
  return bindActionCreators({ getClientGroups, fetchGroupClients }, dispatch);
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(GroupsSearchModal);
